import React, { useState } from "react";
import Modal from "react-responsive-modal";
import ClipLoader from "react-spinners/ClipLoader";

const AdjustQuantityModal = ({ open, setOpen, item, updateQuantity }) => {
  const [newQuantity, setNewQuantity] = useState(item?.quantity || 1);
  const [loading, setLoading] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [isQuantityChanged, setIsQuantityChanged] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setValidationMessage("");
    setIsQuantityChanged(false);
  };

  const handleConfirm = () => {
    if (newQuantity > 0) {
      if (newQuantity > item.product.stock_quantity) {
        setValidationMessage(
          `Available stock is ${item.product.stock_quantity}. You can't order more than that.`
        );
      } else {
        setLoading(true);
        updateQuantity(newQuantity);
        setLoading(false);
        handleClose();
      }
    } else {
      alert("Quantity must be greater than 0");
    }
  };

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value > 0) {
      setNewQuantity(value);
      setValidationMessage("");

      setIsQuantityChanged(value !== (item?.quantity || 1));
    } else {
      setNewQuantity(1);
    }
  };

  return (
    <Modal open={open} onClose={handleClose} center>
      <div className="container px-5 pt-5 custom-modal">
        <div className="row">
          <div className="col-12">
            <h2>Adjust Quantity</h2>
          </div>
          <div className="col-12 mt-3">
            <label htmlFor="quantity">Quantity</label>
            <input
              type="number"
              className="form-control mb-0"
              id="quantity"
              name="quantity"
              value={newQuantity}
              onChange={handleQuantityChange}
              min="1"
              step="1"
            />
            {validationMessage && (
              <p className="text-danger mt-2">{validationMessage}</p>
            )}
          </div>
          <div className="col-12 mt-3">
            <div className="d-flex justify-content-end align-items-center">
              <button
                className="btn btn-solid"
                onClick={handleConfirm}
                disabled={loading || newQuantity < 1 || !isQuantityChanged}
                type="button"
              >
                {loading ? "Updating..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AdjustQuantityModal;
